import * as Yup from 'yup'

const fastSellProductFormSchema = Yup.object().shape({
  seller_id: Yup.string().required(
    'Seller harus diisi'
  ),
  condition: Yup.string().required(
    'Kondisi harus diisi'
  ),
  product_brand_id: Yup.number().required(
    'Brand harus diisi'
  ),
  product_category_id: Yup.number().required(
    'Kategori harus diisi'
  ),
  price_offer: Yup.number()
    .min(50000)
    .required(
      'Penawaran harga harus lebih dari Rp.50.000,-'
    ),
  name: Yup.string().required(
    'Nama produk harus diisi'
  )
})

export default fastSellProductFormSchema
